import { StationDevicesDropDown, StationsDropDown } from '@/Interface/analysisEmi';
import { DatePipe } from '@angular/common';
import { Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { UtilityService } from '@services/utility.service';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import * as Highcharts from 'highcharts';
import { ToastrService } from 'ngx-toastr';
import { PermissionsService } from '@services/permissions.service';
import { DEFAULT_PERMISSIONS } from '@/constants/constants';

@Component({
  selector: 'app-inverter-comparison',
  templateUrl: './inverter-comparison.component.html',
  styleUrls: ['./inverter-comparison.component.scss']
})
export class InverterComparisonComponent implements OnInit {
  Highcharts: typeof Highcharts = Highcharts;

  // Plant 1 data
  selectedPlant1: StationsDropDown | null = null;
  selectedInverter1: StationDevicesDropDown | null = null;
  deviceList1: StationDevicesDropDown[] = [];
  plant1Data: any = null;

  // Plant 2 data
  selectedPlant2: StationsDropDown | null = null;
  selectedInverter2: StationDevicesDropDown | null = null;
  deviceList2: StationDevicesDropDown[] = [];
  plant2Data: any = null;

  // Common data
  allPlantList: StationsDropDown[];

  // Multi line pv chat variables 
  pvVoltages: string[] = [];
  pvCurrents: string[] = [];
  pvEnergy: string[] = [];
  pvPowers: string[] = [];
  pvTemperature: string[] = [];
  pvPercentage: string[] = [];
  pvFrequency: string[] = [];

  // Selected filters
  selectedVoltages: string[] = [];
  selectedCurrents: string[] = [];
  selectedEnergy: string[] = [];
  selectedPowers: string[] = [];
  selectedTemperature: string[] = [];
  selectedPercentage: string[] = [];
  selectedFrequency: string[] = [];

  pvGraphRes: any[];
  pvGraphKey: any[];
  public lineChartLabels: Array<any> = [];

  private colorObj: { [key: string]: string } = {
    current: '#FFBF00',
    frequency: '#02D3C8',
    power: '#414141',
    temperature: '#FF7800',
    voltage: '#EF4323',
    energy: '#23B762',
    percentage: '#0E9CFF',
  };

  public selectedPVDate: Date = new Date(); // Set today by default
  // Add these properties to your component
  filteredPlantList1: StationsDropDown[] = [];
  filteredPlantList2: StationsDropDown[] = [];


  datePickerConfig: Partial<BsDaterangepickerConfig> = {
    dateInputFormat: 'MM/DD/YYYY',
    showWeekNumbers: false,
    adaptivePosition: true,
  };

  public pvMultilineChartOptions!: Highcharts.Options;
  @ViewChildren('pvMultiChart') pvMultiCharts: QueryList<any>;
  @ViewChild('pvMultiChart') pvMultiChart: any;

  loader = false;
  updateFlag = false;

  private previousSelections = {
    voltages: [],
    currents: [],
    powers: [],
    energy: [],
    percentage: [],
    temperature: [],
    frequency: []
  };
  permissions = { ...DEFAULT_PERMISSIONS };
  permissionsReady: boolean = false;
  constructor(
    private _utilityService: UtilityService,
    private datePipe: DatePipe,
    private toaster: ToastrService,
    private permService: PermissionsService,
  ) { }

  ngOnInit(): void {
    this.initComponent();
  }
  async initComponent() {
    this.loader = true
    await this.getComponentPermissions();
    if (this.permissions.canView) {
      this.getPlantsDropDown();
    }
    setTimeout(() => {
      this.loader = false;
    }, 250);
  }

  async getComponentPermissions() {
    const url = this.permService.getCurrentUrl();
    // const menuFromLocal = this.permService.loadMenuFromLocalStorage();
    const menuFromLocal = await this.permService.waitForMenuInLocalStorage();

    const matchedMenu = this.permService.findMenuPermissions(menuFromLocal, url);

    this.permissions = matchedMenu
      ? {
        canAdd: !!matchedMenu.canAdd,
        canEdit: !!matchedMenu.canEdit,
        canView: !!matchedMenu.canView,
        canDelete: !!matchedMenu.canDelete
      }
      : { ...DEFAULT_PERMISSIONS };

    this.permissionsReady = true;
  }
  get hasAnyActionPermission(): boolean {
    return (
      this.permissionsReady &&
      (this.permissions.canView ||
        this.permissions.canEdit ||
        this.permissions.canDelete)
    );
  }

  // Plant 1 Selection Handlers
  // public selectPlant1(plant: StationsDropDown): void {
  //   this.selectedPlant1 = plant;
  //   this.selectedInverter1 = null;
  //   this.plant1Data = null;

  //   if (plant) {
  //     this.getDevicesByPlant1(plant.stationCode);
  //   } else {
  //     this.deviceList1 = [];
  //     this.clearDropdownsIfNoData();

  //   }
  // }
  public selectInverter1(device: StationDevicesDropDown): void {
    this.selectedInverter1 = device;

    if (device && this.selectedPVDate) {
      this.fetchPlant1Data(device.devId, this.selectedPVDate);
    } else {
      this.plant1Data = null;
      this.clearDropdownsIfNoData();
    }
  }

  // Plant 2 Selection Handlers
  // public selectPlant2(plant: StationsDropDown): void {
  //   this.selectedPlant2 = plant;
  //   this.selectedInverter2 = null;
  //   this.plant2Data = null;

  //   if (plant) {
  //     this.getDevicesByPlant2(plant.stationCode);
  //   } else {
  //     this.deviceList2 = [];
  //     this.clearDropdownsIfNoData();

  //   }
  // }
  public selectInverter2(device: StationDevicesDropDown): void {
    this.selectedInverter2 = device;

    if (device && this.selectedPVDate) {
      this.fetchPlant2Data(device.devId, this.selectedPVDate);
    } else {
      this.plant2Data = null;
      this.clearDropdownsIfNoData();
    }
  }
  // Add this new method to filter plant lists
  updateFilteredPlantLists(): void {
    if (!this.allPlantList) {
      this.filteredPlantList1 = [];
      this.filteredPlantList2 = [];
      return;
    }

    // Filter Plant 1 list: exclude Plant 2's selection
    this.filteredPlantList1 = this.selectedPlant2
      ? this.allPlantList.filter(plant => plant.stationCode !== this.selectedPlant2.stationCode)
      : [...this.allPlantList];

    // Filter Plant 2 list: exclude Plant 1's selection
    this.filteredPlantList2 = this.selectedPlant1
      ? this.allPlantList.filter(plant => plant.stationCode !== this.selectedPlant1.stationCode)
      : [...this.allPlantList];
  }

  // Update selectPlant1 method
  public selectPlant1(plant: StationsDropDown): void {
    this.selectedPlant1 = plant;
    this.selectedInverter1 = null;
    this.plant1Data = null;

    // Update filtered lists
    this.updateFilteredPlantLists();

    if (plant) {
      this.getDevicesByPlant1(plant.stationCode);
    } else {
      this.deviceList1 = [];
      this.clearDropdownsIfNoData();
    }
  }

  // Update selectPlant2 method
  public selectPlant2(plant: StationsDropDown): void {
    this.selectedPlant2 = plant;
    this.selectedInverter2 = null;
    this.plant2Data = null;

    // Update filtered lists
    this.updateFilteredPlantLists();

    if (plant) {
      this.getDevicesByPlant2(plant.stationCode);
    } else {
      this.deviceList2 = [];
      this.clearDropdownsIfNoData();
    }
  }


  // Fetch devices for Plant 1
  getDevicesByPlant1(stationCode: any): void {
    this.deviceList1 = [];
    const type = 1
    if (stationCode) {
      this._utilityService.getStationInverterData(stationCode, type).subscribe({
        next: (res) => {
          this.deviceList1 = res || [];
        },
        error: () => {
          this.deviceList1 = [];
        }
      });
    }
  }

  // Fetch devices for Plant 2
  getDevicesByPlant2(stationCode: any): void {
    this.deviceList2 = [];
    const type = 1
    if (stationCode) {
      this._utilityService.getStationInverterData(stationCode, type).subscribe({
        next: (res) => {
          this.deviceList2 = res || [];
        },
        error: () => {
          this.deviceList2 = [];
        }
      });
    }
  }

  // Fetch data for Plant 1
  fetchPlant1Data(devId: number, date: Date): void {
    if (!date) {
      this.toaster.warning('Date is required.');
      return;
    }

    this.loader = true;
    const formattedDate = this.datePipe.transform(date, 'yyyy-MM-dd');

    this._utilityService.newPvGraphsList(devId, formattedDate).subscribe({
      next: (res) => {
        if (res) {
          this.plant1Data = res;
          console.log('Plant 1 Data:', this.plant1Data);
          this.toaster.success('Plant 1 data loaded successfully');

          // Update dropdowns and chart if needed
          this.updateDropdownsAndChart();
        }
        this.loader = false;
      },
      error: (err) => {
        console.error('Error fetching Plant 1 data:', err);
        this.toaster.error('Failed to load Plant 1 data');
        this.loader = false;
      }
    });
  }

  // Fetch data for Plant 2
  fetchPlant2Data(devId: number, date: Date): void {
    if (!date) {
      this.toaster.warning('Date is required.');
      return;
    }

    this.loader = true;
    const formattedDate = this.datePipe.transform(date, 'yyyy-MM-dd');

    this._utilityService.newPvGraphsList(devId, formattedDate).subscribe({
      next: (res) => {
        if (res) {
          this.plant2Data = res;
          console.log('Plant 2 Data:', this.plant2Data);
          this.toaster.success('Plant 2 data loaded successfully');

          // Update dropdowns and chart if needed
          this.updateDropdownsAndChart();
        }
        this.loader = false;
      },
      error: (err) => {
        console.error('Error fetching Plant 2 data:', err);
        this.toaster.error('Failed to load Plant 2 data');
        this.loader = false;
      }
    });
  }

  // Handle date change
  onDateChange(newDate: Date): void {
    this.selectedPVDate = newDate;

    // Refetch data for both plants if inverters are selected
    if (this.selectedInverter1) {
      this.fetchPlant1Data(this.selectedInverter1.devId, newDate);
    }

    if (this.selectedInverter2) {
      this.fetchPlant2Data(this.selectedInverter2.devId, newDate);
    }
  }

  // Update dropdowns and chart based on loaded data
  updateDropdownsAndChart(): void {
    if (this.plant1Data || this.plant2Data) {
      const data1 = this.plant1Data?.[0]?.dropdown_keys || {};
      const data2 = this.plant2Data?.[0]?.dropdown_keys || {};

      // Merge unique values
      this.pvVoltages = [...new Set([...(data1.voltages || []), ...(data2.voltages || [])])];
      this.pvCurrents = [...new Set([...(data1.currents || []), ...(data2.currents || [])])];
      this.pvEnergy = [...new Set([...(data1.energy || []), ...(data2.energy || [])])];
      this.pvPowers = [...new Set([...(data1.powers || []), ...(data2.powers || [])])];
      this.pvTemperature = [...new Set([...(data1.temperature || []), ...(data2.temperature || [])])];
      this.pvPercentage = [...new Set([...(data1.percentage || []), ...(data2.percentage || [])])];
      this.pvFrequency = [...new Set([...(data1.frequency || []), ...(data2.frequency || [])])];

      // Use the time data that has more points, or plant1 as default
      const time1 = this.plant1Data?.[0]?.time || [];
      const time2 = this.plant2Data?.[0]?.time || [];
      const timeData = time1.length >= time2.length ? time1 : time2;

      if (timeData.length > 0) {
        this.processGraphTime(timeData);
      }

      // Update chart if filters are selected
      if (this.hasFiltersSelected()) {
        this.SetGraphData();
      }
    }
  }

  // Get plants dropdown
  getPlantsDropDown(): void {
    this._utilityService.getStationsDropDown().subscribe((res) => {
      if (res) {
        this.allPlantList = res.data;
        this.updateFilteredPlantLists();
      }
    });
  }

  processGraphTime(arrTime: any): void {
    this.lineChartLabels.length = 0;
    arrTime.forEach((e) => {
      const date = new Date(Number(e) * 1000);
      const time = this.datePipe.transform(date, 'hh:mm a');
      this.lineChartLabels.push(time);
    });
  }

  hasFiltersSelected(): boolean {
    return (
      (this.selectedVoltages?.length ?? 0) > 0 ||
      (this.selectedCurrents?.length ?? 0) > 0 ||
      (this.selectedPowers?.length ?? 0) > 0 ||
      (this.selectedEnergy?.length ?? 0) > 0 ||
      (this.selectedPercentage?.length ?? 0) > 0 ||
      (this.selectedTemperature?.length ?? 0) > 0 ||
      (this.selectedFrequency?.length ?? 0) > 0
    );
  }

  onDropdownSelectionChange(): void {
    const yAxisTypeCount = this.getSelectedYAxisCount();

    if (yAxisTypeCount > 3) {
      this.toaster.warning('You can select a maximum of 3 filter types for Y-axis.');

      // Revert to previous selections
      this.selectedVoltages = [...this.previousSelections.voltages];
      this.selectedCurrents = [...this.previousSelections.currents];
      this.selectedPowers = [...this.previousSelections.powers];
      this.selectedEnergy = [...this.previousSelections.energy];
      this.selectedPercentage = [...this.previousSelections.percentage];
      this.selectedTemperature = [...this.previousSelections.temperature];
      this.selectedFrequency = [...this.previousSelections.frequency];

      return;
    }

    // Store current selections as valid
    this.previousSelections = {
      voltages: [...this.selectedVoltages],
      currents: [...this.selectedCurrents],
      powers: [...this.selectedPowers],
      energy: [...this.selectedEnergy],
      percentage: [...this.selectedPercentage],
      temperature: [...this.selectedTemperature],
      frequency: [...this.selectedFrequency]
    };

    this.performChartUpdate();
  }

  getSelectedYAxisCount(): number {
    let count = 0;

    if (this.selectedVoltages && this.selectedVoltages.length) count++;
    if (this.selectedCurrents && this.selectedCurrents.length) count++;
    if (this.selectedPowers && this.selectedPowers.length) count++;
    if (this.selectedEnergy && this.selectedEnergy.length) count++;
    if (this.selectedPercentage && this.selectedPercentage.length) count++;
    if (this.selectedTemperature && this.selectedTemperature.length) count++;
    if (this.selectedFrequency && this.selectedFrequency.length) count++;

    return count;
  }

  performChartUpdate(): void {
    setTimeout(() => {
      this.updateChartSeries();
    }, 0);
  }

  SetGraphData(): void {
    if (!this.hasFiltersSelected()) {
      console.warn('No filters selected, skipping chart update.');
      this.pvMultilineChartOptions = null;
      return;
    }

    if ((!this.plant1Data || !this.plant1Data[0]) && (!this.plant2Data || !this.plant2Data[0])) {
      console.error('No graph data available');
      return;
    }

    this.updateChartSeries();
  }

  updateChartSeries(): void {
    const newSeries: Highcharts.SeriesOptionsType[] = [];
    let seriesIndex = 0;

    const safeData = (arr?: (number | null)[]) =>
      (arr ?? []).map(v => (v === 0 || v == null ? null : v));

    const dynamicYAxes = this.createDynamicYAxes();
    const axisMap: Record<string, number> = {};
    let axisCounter = 0;

    const mapAxis = (keys: string[], type: string) => {
      // Check if ANY plant has data for this metric type
      const hasPlant1Data = keys.some(key => this.plant1Data?.[0]?.[key]);
      const hasPlant2Data = keys.some(key => this.plant2Data?.[0]?.[key]);

      if (hasPlant1Data || hasPlant2Data) {
        axisMap[type] = axisCounter++;
      }
    };

    mapAxis(this.selectedVoltages, 'voltage');
    mapAxis(this.selectedCurrents, 'current');
    mapAxis(this.selectedPowers, 'power');
    mapAxis(this.selectedEnergy, 'energy');
    mapAxis(this.selectedPercentage, 'percentage');
    mapAxis(this.selectedTemperature, 'temperature');
    mapAxis(this.selectedFrequency, 'frequency');

    const formatTooltipValue = (value: number, unit: string): string => {
      if (unit === 'W') {
        if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(2)} GW`;
        if (value >= 1_000) return `${(value / 1_000).toFixed(2)} MW`;
        return `${value.toFixed(2)} KW`;
      }

      if (value >= 1_000_000_000) return `${(value / 1_000_000_000).toFixed(2)} G${unit}`;
      if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(2)} M${unit}`;
      if (value >= 1_000) return `${(value / 1_000).toFixed(2)} K${unit}`;
      return `${value} ${unit}`;
    };

    const addSeries = (keys: string[], type: string, unit: string) => {
      if (axisMap[type] !== undefined) {
        keys.forEach(key => {
          // Add Plant 1 series if data exists
          if (this.plant1Data?.[0]?.[key]) {
            newSeries.push({
              name: `${this.selectedPlant1?.stationName || 'Plant 1'} - ${this.formatSeriesName(key)}`,
              type: 'line',
              yAxis: axisMap[type],
              data: safeData(this.plant1Data[0][key]),
              color: this.generateComparisonSeriesColor(type, 1, seriesIndex),
              dashStyle: 'Solid', // Solid line for Plant 1
              tooltip: {
                pointFormatter: function () {
                  const formattedValue = formatTooltipValue(this.y || 0, unit);
                  return `<span style="color:${this.color}">●</span> ${this.series.name}: <b>${formattedValue}</b><br/>`;
                }
              },
              turboThreshold: 0,
              lineWidth: 2,
              marker: {
                enabled: false,
                symbol: 'circle',
                radius: 4
              }
            });
            seriesIndex++;
          }

          // Add Plant 2 series if data exists
          if (this.plant2Data?.[0]?.[key]) {
            newSeries.push({
              name: `${this.selectedPlant2?.stationName || 'Plant 2'} - ${this.formatSeriesName(key)}`,
              type: 'line',
              yAxis: axisMap[type],
              data: safeData(this.plant2Data[0][key]),
              color: this.generateComparisonSeriesColor(type, 2, seriesIndex),
              dashStyle: 'Dash', // Dashed line for Plant 2
              tooltip: {
                pointFormatter: function () {
                  const formattedValue = formatTooltipValue(this.y || 0, unit);
                  return `<span style="color:${this.color}">●</span> ${this.series.name}: <b>${formattedValue}</b><br/>`;
                }
              },
              turboThreshold: 0,
              lineWidth: 2,
              marker: {
                enabled: false,
                symbol: 'circle',
                radius: 4
              }
            });
            seriesIndex++;
          }
        });
      }
    };

    addSeries(this.selectedVoltages, 'voltage', 'V');
    addSeries(this.selectedCurrents, 'current', 'A');
    addSeries(this.selectedPowers, 'power', 'W');
    addSeries(this.selectedEnergy, 'energy', 'J');
    addSeries(this.selectedPercentage, 'percentage', '%');
    addSeries(this.selectedTemperature, 'temperature', '°C');
    addSeries(this.selectedFrequency, 'frequency', 'Hz');

    this.pvMultilineChartOptions = {
      chart: {
        zooming: { type: 'xy' },
        type: 'line',
        backgroundColor: 'transparent',
        height: 500,
        width: null,
        marginBottom: 130, // Increase from 80 to 100 for more legend space
      },
      title: { text: '' },
      credits: { enabled: false },
      xAxis: {
        type: 'category',
        categories: [...this.lineChartLabels],
        crosshair: true
      },
      yAxis: dynamicYAxes,
      tooltip: { shared: true },
      legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
        y: 0, // Change from 40 to 0
        itemStyle: {
          // fontSize: '11px',
          // fontWeight: 'normal',
          textOverflow: 'ellipsis',
          width: 150 // Limit width per item
        },
        itemDistance: 8, // Add spacing between items
        symbolRadius: 8, // Reduce from 16 to 8
        symbolWidth: 14,
        symbolHeight: 10,
        maxHeight: 70, // Add max height for legend area
        navigation: {
          enabled: true,
          activeColor: '#3E576F',
          animation: true,
          arrowSize: 12,
          style: {
            fontWeight: 'normal',
            fontSize: '11px'
          }
        }
      },
      plotOptions: {
        series: {
          connectNulls: true,
          marker: {
            enabled: false,
            symbol: 'circle'
          }
        }
      },
      series: newSeries,
      responsive: {
        rules: [{
          condition: { maxWidth: 500 },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom',
              itemStyle: {
                fontSize: '10px'
              }
            }
          }
        }]
      }
    };
    if (!newSeries.length) {
      this.pvMultilineChartOptions = null;
      return;
    }

    this.updateChart();
  }

  createDynamicYAxes(): Highcharts.YAxisOptions[] {
    const axes: Highcharts.YAxisOptions[] = [];
    let axisCount = 0;

    const hasData = (data?: (number | null)[]) =>
      data?.some(v => v != null) ?? false;

    const formatWithUnit = (value: number, unit: string): string => {
      if (unit === 'W') {
        if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}GW`;
        if (value >= 1_000) return `${(value / 1_000).toFixed(1)}MW`;
        return `${value}KW`;
      }

      if (value >= 1_000_000_000) return `${(value / 1_000_000_000).toFixed(1)}G${unit}`;
      if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M${unit}`;
      if (value >= 1_000) return `${(value / 1_000).toFixed(1)}K${unit}`;
      return `${value}${unit}`;
    };

    const addAxis = (keys: string[], type: keyof typeof this.colorObj, unit: string) => {
      if (axisCount >= 3) return;

      const containsData = keys.some(key =>
        hasData(this.plant1Data?.[0]?.[key]) || hasData(this.plant2Data?.[0]?.[key])
      );

      if (containsData) {
        axes.push({
          gridLineWidth: axisCount === 0 ? 1 : 0,
          labels: {
            style: { color: this.colorObj[type] },
            formatter: function () {
              const val = this.value as number;
              return formatWithUnit(val, unit);
            }
          },
          title: {
            text: this.capitalize(type),
            style: {
              color: this.colorObj[type],
              fontWeight: 'bold'
            }
          },
          opposite: axisCount !== 0,
        });
        axisCount++;
      }
    };

    addAxis(this.selectedVoltages, 'voltage', 'V');
    addAxis(this.selectedCurrents, 'current', 'A');
    addAxis(this.selectedPowers, 'power', 'W');
    addAxis(this.selectedEnergy, 'energy', 'J');
    addAxis(this.selectedPercentage, 'percentage', '%');
    addAxis(this.selectedTemperature, 'temperature', '°C');
    addAxis(this.selectedFrequency, 'frequency', 'Hz');

    return axes;
  }

  updateChart(): void {
    this.pvMultilineChartOptions = { ...this.pvMultilineChartOptions };
    this.updateFlag = !this.updateFlag;

    setTimeout(() => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (this.pvMultiChart?.chart) {
            this.pvMultiChart.chart.reflow();
            const containerWidth = this.pvMultiChart.chart.container.offsetWidth;
            const containerHeight = this.pvMultiChart.chart.container.offsetHeight;
            this.pvMultiChart.chart.setSize(containerWidth, containerHeight, false);
          }
        });
      });
    }, 0);
  }

  clearPVChart(): void {
    this.clearChartSeries();
    this.clearAllDropdownSelections();
  }

  clearChartSeries(): void {
    if (!this.pvMultilineChartOptions) return;

    this.pvMultilineChartOptions.series = [];

    if (Array.isArray(this.pvMultilineChartOptions.xAxis)) {
      (this.pvMultilineChartOptions.xAxis[0] as any).categories = [];
    }

    this.updateChart();
  }

  clearAllDropdownSelections(): void {
    this.selectedVoltages = [];
    this.selectedCurrents = [];
    this.selectedPowers = [];
    this.selectedEnergy = [];
    this.selectedPercentage = [];
    this.selectedTemperature = [];
    this.selectedFrequency = [];

    this.previousSelections = {
      voltages: [],
      currents: [],
      powers: [],
      energy: [],
      percentage: [],
      temperature: [],
      frequency: []
    };
  }

  capitalize(text: any): string {
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  generateComparisonSeriesColor(type: string, plantNumber: 1 | 2, index: number): string {
    const baseColor = this.colorObj[type];

    // Plant 2 gets slightly lighter shade
    if (plantNumber === 2) {
      const opacity = Math.max(0.6, 0.9 - (index * 0.1));
      return baseColor + Math.round(opacity * 255).toString(16).padStart(2, '0');
    }

    // Plant 1 gets full opacity
    const opacity = Math.max(0.7, 1 - (index * 0.1));
    return baseColor + Math.round(opacity * 255).toString(16).padStart(2, '0');
  }

  formatSeriesName(key: string): string {
    return key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
  }
  clearDropdownsIfNoData(): void {
    // Only clear dropdowns if both plants have no data
    if (!this.plant1Data && !this.plant2Data) {
      this.pvVoltages = [];
      this.pvCurrents = [];
      this.pvEnergy = [];
      this.pvPowers = [];
      this.pvTemperature = [];
      this.pvPercentage = [];
      this.pvFrequency = [];
      this.lineChartLabels = [];

      // Also clear selected filters
      this.clearAllDropdownSelections();

      // Clear chart
      this.pvMultilineChartOptions = null;
    } else {
      // If one plant still has data, update dropdowns with remaining data
      this.updateDropdownsAndChart();
    }
  }

}
